import React from "react";

const Input = props => {
  //console.log(props.value);
  return (

      <input
        className={props.styleName}
        id={props.name}
        name={props.name}
        type={props.inputType}
        value={props.value}
        onChange={props.handleChange}
        placeholder={props.placeholder}
        {...props}
      />

  );
};

export default Input;
